import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>ஸமிதாதானம்</h1>
<div class="head2">
  ஸமிதாதானம் வீடியோ
</div>
<ion-item>
  <div class="video-container">
    <iframe src="https://www.youtube.com/embed/ItbIBlIvUf8?rel=0" frameborder="0" width="300" height="169"></iframe>
  </div>
</ion-item>
<div class="svk">
  உபநயனத்தில்&nbsp; ப்ரஹ்மோபதேசம் ஆனது முதற்கொண்டு, 
  ப்ராஜாபத்யாதி நான்கு காண்டருஷிகளுக்கும் உபக்ரம உத்ஸர்ஸனம் 
  எனப்படும் அஷ்ட
  வ்ரதம் செய்து முடிக்கும்வரை ஒருவன் ப்ரஹ்மச்சாரிக்குரிய 
  அநுஷ்டானங்களைக் கடைப்பிடிக்கவேண்டும். வ்ரதத்தன்று சங்கல்பத்தில்
  : ப்ரஹ்மச்சர்ய ஆச்ரமோக்த ப்ராத: ஸ்நாந, ஸந்தியா வந்தன,
   ஸமிதாதான, குருகுலவாஸ, ப்ரஹ்ம யஜ்ஞ, பிக்ஷாசரண, மெளஞ்சி, மேகலா,
  அஜின, தண்ட தாரண என்பவைகளை அநுட்டியாத தோஷத்திற்காக 
  ப்ராயச்சித்தம் சொல்லப் பட்டுள்ளது. எனவே மேற்கண்ட அனைத்தையும் ஒரு
  ப்ரஹ்மச்சாரி நித்யம் அநுஷ்டிக்கவேண்டும் எனத் தெரிகிறது. 
  தவிர, வாசனாதி திரவியங்களைப் பூசிக்கொள்வது, புஷ்பம், சந்தனம்,
  மாலை போன்றவற்றை உபயோகிப்பது, உணவில் உப்பு, 
  காரம் நிறைவாகச் சேர்த்துக் கொள்வது, பெண்களுடன் பேசுவது போன்றவைகளையும்
  தவிர்க்கவேண்டும் எனத் தெரிகிறது. தினமும் ஸமிதாதானம் 
  பண்ணும் ப்ரம்ஹசாரியை எக்காரணம் கொண்டும்&nbsp; 
  காலதேவன் விதி முடிந்தாலும்
  பிடிக்கக் கூடாது என்றும், எந்த ப்ரஹ்மச்சாரி என்றைய 
  தினம் ஸமிதாதானம் செய்யவில்லையோ அன்றைய தினம் 
  அவனை ம்ருத்யு எனப்படும்
  காலதேவன் விதிவசமானால் பிடித்துக் கொள்ளலாம் என்று
   நாரதர் பெருமாளிடம் வரம் பெற்றுள்ளார் எனவும் வேதத்தில் காணப்படுகிறது.
  <br
  /> &nbsp;&nbsp; எனவே ப்ரஹ்மச்சாரியாக மரணம் ஏற்படாமல் 
  தவிர்க்கும் பொருட்டு, தினமும் ஸமிதாதானம் பண்ணுவது நன்று. 
  ப்ராதஸ்ஸ்நாந
  ஸந்தியாவந்தனங்கள் க்ருஹஸ்தர்களைப் போலவே பண்ணவேண்டும்.
</div>
<div class="hint">
  ஸமிதாதானம் பண்ண ஒரு மண் மடக்கு இருந்தாலே போறும். ஸமித்துக் குச்சிகளால் பண்ணுவது சிறப்பு, கிடைக்காவிட்டால் சிறு தர்பத் துண்டுகளை
  வைத்துக்கொண்டே பண்ணிவிடலாம். 1. ஒரு மண் மடக்கு அல்லது சிறு ஹோம குண்டம் 2. சிறு துண்டு கற்பூரம், தீப்பெட்டி 3. மெலிதாக
  20 ஸமித்துக் குச்சிகள் அல்லது 40 துண்டு தர்பங்கள் தேவை.
</div>
<hr class="new">

<div class="hint">
         இரண்டு தரம் ஆசமனம் பண்ணி, 2 தர்ப்ப பவித்ரம் 
         போட்டுக்கொண்டு 
         இரண்டு தர்ப்பம் ஆஸனம், 
       இரண்டு தர்ப்பம் பவித்ர விரலில் இடுக்கிக்கொண்டு 
       ப்ராணாயாமம்.</div>
       <div class="prayogam">
       '..... ஸ்ரீபகதாக்ஞா ......ம் ப்ராத: ஸமிதம் ஆதாஸ்யே" </div>

     <div class="hint">என்று ஸங்கல்பம். </div>
     <hr class="new">
            <h2>அக்னிப்ரதிஷ்டை</h2>
            <div class="hint">ஸ்தல சுத்தி செய்து கோலம் போட்ட படியில் 
     மத்தியில் சோபனாக்ஷதையை சேர்த்து 
     (ஸ்தண்டிலம் கல்பயித்வா...)</div>
      <div class="hint">
     <img src="assets/img/agni-kundam.jpg" style="width:200px; float: left;">
      இரண்டு தர்பத்தை வலது கையில் எடுத்துக் கொண்டு <br>
      மேற்கே ஆரம்பித்து கிழக்கில் முடியுமாறு தெற்கு (வலது) ஓரம் (1),  
      நடு(2), வடக்கு (இடது) ஓரம்(3)  என மூன்று (குத்துக்)
       கோடுகள் தர்ப்பத்தால் கீரவும்,<br>
       பிறகு தெற்கு ஆரம்பித்து வடக்கில் முடியும்படி  
      தென்றே்கு(4), தெற்கு(5), தென்கிழக்கு(6)
        என படத்தில் விவரித்தபடி மூன்று (கிடைக்) 
        கோடுகள் தர்பத்தால் கீரவும்.<br>
       
   கோடு கீற உபயோகித்த தர்ப்பத்தை தீர்த்ததால் ப்ரோக்ஷித்து 
   நிரிதி (தென் மேற்கு) திக்கில் சேர்க்கவும்.</div>
   <div class="prayogam"> 'பூர்புஸ்ஸுவ: ஓம்"</div>
   <div class="hint"> என்று அக்னியை (தணல் அல்லது 
     கற்பூர அக்நி சேர்த்து) 
     ப்ரதிஷ்டை  செய்யவும். </div>
     <hr class="new">
   <div class="prayogam"> 
     <img src="assets/img/kaikoopu.jpg" class="img2"> 
      பரித்வாக்னே 
     பரிமிருஜாமி ஆயுஷாச தநேநச ஸுப்ரஜா: 
       ப்ரஜயா பூயாஸம் ஸுவீரோ வீரை: 
       ஸுவர்ச்சா வர்ச்சஸா ஸுபோஷ: போஷை: 
       ஸுக்ருஹோ
        க்ருஹை: ஸுபதி: பத்யா ஸுமேதா 
        மேதயா ஸுப்ரம்ஹா ப்ரம்ஹசாரிபி:"
   </div>
   <div class="hint"> இந்த மந்திரத்தை  கைகளைக் கூப்பிக்கொண்டு
      சொல்லவும்.</div>
      <hr class="new">
      <h2>பரிஷேசனம்</h2>
      <div class="hint">வலது உள்ளங்கையில் ஜலம் எடுத்துக்கொண்டு, 
   அக்நி குண்டத்திற்கு வலது புறம் (தெற்கே) 
   மேற்கு மூலையிலிருந்து கிழக்கு மூலை வரை ஜலம் விட்டு,</div> 
   <div class="prayogam">"அதிதே அநுமந்யஸ்வ"</div>
   <div class="hint"> என்று சொல்லவும். <br>
   அக்நிக்கு மேற்கே தென் மூலையிலிருந்து வட மூலைவரை ஜலம் விட்டு</div> 
   "அநுமதே அநுமந்யஸ்வ" 
   <div class="hint">அக்நிக்கு வடக்கே மேற்கு 
     மூலையிலிருந்து கிழக்கு மூலைவரை ஜலம் விட்டு </div>
     'ஸரஸ்வதே அநுமந்யஸ்வா" என்றும்,
     <div class="hint">வடமேற்கு (ஈசான்ய) மூலையில் ஆரம்பித்து 
       ஆரம்பித்த இடத்தில் முடியும்படி ப்ரதக்ஷpணமாக ஜலம் விட்டு</div> 
       'தேவ ஸவித: ப்ரஸுவ" 
       <div class="hint">என்றும் சொல்லவேண்டியது
          இதற்கு பூர்வ பரிசேஷணம் என்று பெயர்.<br>
   பிறகு ஸமித் (அல்லது தர்ப்பம் (2) இரண்டு இரண்டாக) 
   அக்நியில் கீழ்வரும் மந்திரங்களைச் சொல்லி சேர்க்கவும். </div>
<h2>ஸமிதாதான ஹோமம்</h2>
       <div class="prayogam">
         01.	ஓம் அக்னயே ஸமிதம் ஆஹார்ஷம் 
         ப்ருஹதே ஜாதவேதஸே யதாத்வம் அக்னே 
         ஸமிதா ஸமித்யஸே ஏவம் மாமாயுஷா 
         வர்ச்சஸா ஸந்யா மேதயா ப்ரஜயா பசுபி: 
         ப்ரம்ஹவர்ச்சஸேன அந்நாத்யேந ஸமேதய ஸ்வாஹா.
       <br>02.	ஏதோஸி ஏதிஷீமஹி ஸ்வாஹா 
       <br>03.	ஸமிதஸி ஸமேதிஷீமஹி ஸ்வாஹா, 
       <br>04.	தேஜோஸி தேஜோமயிதேஹி ஸ்வாஹா, 
       <br>05.	அபோ அத்யா அந்வசாரிஷம் ரஸேந 
       ஸமஸ்ருக்ஷ்மஹி பயஸ்வாந் அக்ன ஆகமம் தம்மா 
       ஸகும்ஸ்ருஜ வர்சஸா ஸ்வாஹா
       <br>06.	ஸம்மாக்நே வர்சஸா ஸ்ருஜா ப்ரஜயாச தநேநச ஸ்வாஹா, 	
       <br>07.	வித்யுந்மே அஸ்யதேவா: இந்த்ரோவித்யாத் 
       ஸஹரிஷியி ஸ்வாஹா 
       <br>08.	அக்நயே ப்ருஹதே நாகாய ஸ்வாஹா, 
       <br>09.	த்யாவா ப்ருதிவீப்யாம் ஸ்வாஹா 
       <br>10.	ஏஷாதே அக்நே ஸமித்தயயா வர்தஸ்வச 
       ஆப்பியாயஸ்வச தயாஹம் வர்த்தமான: பூயாஸம் 
           ஆப்யாயமாநச்ச ஸ்வாஹா
       <br>11.	யோமாக்னே பாகிநம் ஸந்தம் அதாபாகம் 
       சிகீர்ஷதி அபாகமக்நே தம்குரு மாமக்னே பாகிநம்குரு ஸ்வாஹா, 
       <br>12.	ஸமிதமாதாய அக்நே ஸர்வ வ்ருதோ பூயாஸம் ஸ்வாஹா 
       <br>13.	ஓம்பூஸ்வாஹா
       <br>	14.	ஓம்புவஸ்ஸ்வாஹா
       <br> 15.	ஓம்ஸுவஸ்ஸ்வாஹா
       <br>16.	ஓம்பூர்புவஸ்ஸுவஸ்ஸ்வாஹா</div>
<h2>உத்ர பரிஷேசனம்</h2>
      <div class="hint"> வலது உள்ளங்iகியில் ஜலம் எடுத்துக்கொண்டு, 
        அக்நி குண்டத்திற்கு வலது புறம் (தெற்கே) 
        மேற்கு மூலையிலிருந்து கிழக்கு மூலை வரை ஜலம் விட்டு</div> 
        'அதிதேஅந்வமக்குஸ்தா:" 
        <div class="hint">என்று சொல்லவும் 
   <br>அக்நிக்கு மேற்கே தென் மூலையிலிருந்து வட மூலைவரை 
   ஜலம் விட்டு </div>
   'அநுமதே அந்வமக்குஸ்தா:" 
   <div class="hint">என்றும்<br>
   அக்நிக்கு வடக்கே மேற்கு மூலையிலிருந்து 
   கிழக்கு மூலைவரை ஜலம் விட்டு </div>
   'ஸரஸ்வதே அந்வமக்குஸ்தா:" 
   <div class="hint">என்றும்,
   <br>வடமேற்கு (ஈசான்ய) மூலையில் ஆரம்பித்து 
   அங்கேயே முடியும்படி ப்ரதக்ஷிணமாக ஜலம் விட்டு</div> 
   'தேவ ஸவித: ப்ராஸாவீ:" 
   <div class="hint">என்றும் சொல்லவேண்டியது இதற்கு 
   உத்தர பரிசேஷணம் என்று பெயர்</div>
   <h2>உபஸ்தானம்</h2>
   'ஸ்ரீ விஷ்ணவே ஸ்வாஹா" 
   <div class="hint">என்று அக்னியில் 2தர்ப்பம் அல்லது 
     ஒரு ஸமித் சேர்க்கவும்.</div> 
   'ஸ்ரீ  விஷ்ணவே பரமாத்மன இதம் நமம" 
   <div class="hint">என்று சொல்லி எழுந்திருந்து நின்று கொண்டு</div> 
   <div class="prayogam">	'யத்தே அக்னே தேஜஸ்தேந 
     அஹம் தேஜஸ்வீ பூயாஸம் 
   <br>	யத்தே அக்நே வர்ச்சஸ்தேந அஹம் வர்ச்சஸ்வீ பூயாஸம் 
   <br>	யத்தே அக்நே ஹரஸ்தேந அஹம் ஹரஸ்வீ பூயாஸம் 
   <br>	மயிமேதாம் மயிப்ரஜாம் மைஅக்னி: தேஜோததாது, 
   <br>	மயிமேதாம் மயிப்ரஜாம்  மை அக்நி: தேஜோததாது, 
   <br>	மயிமேதாம் மயிப்ரஜாம்  மயிந்த்ர: இந்திரியம்ததாது 
   <br>	மயிமேதாம் மயிப்ரஜாம் மயிஸூர்ய: ப்ராஜோததாது, 
   <br>	அக்நயே நம: மந்த்ர ஹீநம் க்ரியா ஹீநம் பக்தி ஹீநம் ஹுதாசந
   <br>	யத்ஹுதந்து மயாதேவ பரிபூர்ணம் ததஸ்துதே. 
   <br>	ப்ராயச்சித்தாநி அசேஷாணி தப:கர்மாத்மகாநிவை
       யாநிதேஷாம் அசேஷாணாம் ஸ்ரீ க்ருஷ்ணாநுஸ்மரணம் பரம்"</div>
       
       
              <img src="assets/img/shastanga-namaskaram.jpg" class="img1" >
              <p class="clear"></p>
              <hr> 
           
                  <img src="assets/img/abhivathi.jpg" class="img1">
                  
              
       <div class="hint">என்று சொல்லி  ஸேவித்து 
          அபிவாதனம் செய்து ஆசமனம் செய்து 
        <br>பவித்திரத்தை முடிச்சை அவிழ்த்து 
        தர்ப்பத்தை கீழே சேர்த்து ஆசமனம் செய்யவும். 
         இதற்கு அக்னி உபஸ்தானம் என்று பெயர்.    
       </div>
      <hr class="new">
<div class="sans">
  श्री ... म् प्रात: (सायं) समिधं आधास्ये ।
  <hr class="new"> परित्वा अग्ने परिमृजामि आयुषा च धनेन च सुप्रजा: प्रजया भूयासं, सुवीर: वीरै: सुवर्चा: वर्चसा, सुपोष: पोषै:, सुगृह: गृहै:,
  सुपति: पत्या, सुमेधा: मेधया, सुब्रह्मा ब्रह्मचारिभि:।
  <hr class="new"> ओं अदिते अनुमन्यस्व।
  <br> अनुमते अनुमन्यस्व।
  <br> सरस्वते अनुमन्यस्व।
  <br> देव स्वित: प्रसुव।
  <br>
  <hr class="new"> अग्नये समिधम् आहार्षं बृहते जातवेदसे।
  <br> यथा त्वमग्ने समिधा समिध्यसे एवं मां आयुषा वर्चसा सन्या मेधया प्रजया पशुभि: ब्रह्मवर्चसेन अन्नाद्येन समेधय स्वाहा।
  <br> एधोऽसि एधिषीमहि स्वाहा।
  <br> तेजोऽसि तेज: मयि धेहि स्वाहा।
  <br> अपो अद्य अन्वचारिषं रसेन समसृक्ष्महि।
  <br> पयस्वान् अग्ने आगमं तं मा सँसृज वर्चसा स्वाहा।
  <br> सं मा अग्ने वर्चसा सृजा प्रजया च धनेन च स्वाहा।
  <br> विद्युन्मे अस्य देवा: इन्द्रो विद्यात् सह ऋषिभि: स्वाहा।
  <br> अग्नये बृहते नाकाय स्वाहा।
  <br> द्यावा पृथिवीभ्यां स्वाहा।
  <br> एषा ते अग्ने समित् तया वर्धस्व च आप्यायस्व च तयाहं वर्धमान: भूयासं आप्यायमानश्च स्वाहा।
  <br> यो मा अग्ने भागिनं सन्तम् अथाभागं चिकीर्षति।
  <br> अभागमग्ने तं कुरु मामग्ने भागिनं कुरु स्वाहा।
  <br> समिधमाधाय अग्ने सर्वव्रत: भूयासं स्वाहा।
  <br> ओं भूस्स्वाहा।
  <br> ओं भुवस्स्वाहा।
  <br> ओँ सुवस्स्वाहा।
  <br> ओं भूर्भुवस्सुवस्स्वाहा।
  <hr class="new"> ओं अदिते अन्वमँस्था:।
  <br> अनुमते अन्वमँस्था:।
  <br> सरस्वते अन्वमँस्था:।
  <br> देवसवित: प्रासावी:।
  <br>
  <hr class="new"> श्रीविष्णवे स्वाहा।
  <br> यत्ते अग्ने तेजस्तेन अहं तेजस्वी भूयासम्।
  <br> यत्ते अग्ने वर्चस्तेन अहं वर्चस्वी भूयासम्।
  <br> यत्ते अग्ने हरस्तेन अहं हरस्वी भूयासम्।
  <br> मयि मेधां मयि प्रजां मय्यग्नि: तेजो दधातु।
  <br> मयि मेधां मयि प्रजां मयीन्द्र: इन्द्रियं दधातु।
  <br> मयि मेधां मयि प्रजां मयि सूर्य: भ्राजो दधातु।
  <br> अग्नये नम: मन्त्र हीनं क्रिया हीनं भक्ति हीनं हुतासन।
  <br> यद्धुतं तु मया देवा परिपूर्णं तदसतु ते ।
  <br> प्रायश्चित्तानि अशेषाणि तप: कर्मात्मकानि वै ।
  <br> यानि तेषाम् अशेषाणां श्रीकृष्णानुस्मरणं परम्।
  <hr class="new">
  
</div>`;

const SamidhadhanamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="ஸமிதாதானம் - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default SamidhadhanamPage;
